export const videoInterviewDataStoreKey = 'videoInterviewData';
